import React from 'react';
import Paper from "@mui/material/Paper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function ShortInfoCard({ label, description, onEdit, editTitle, children }) {
    return (
        <Paper className="short-card" elevation={0}>
            <div className="short-card__label">
                {label}
            </div>
            <div className="short-card__code">
                {description}
            </div>
            <div className="short-card__actions">
                {children}
                <span
                    onClick={onEdit}
                    className="edit"
                    title={editTitle}
                >
                    <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 20 }} />
                </span>
            </div>
        </Paper>
    );
}

export default ShortInfoCard;

